const language = {
    'pt': 
        {
            articles:                   'Notícias',
            articles_list:              'Lista de artigos',
            article_new:                'Novo artigo',
            attributes:                 'Atributos',
            attributes_list:            'Lista de atributos',
            attribute_new:              'Novo atributo',
            attribute_values:           'Valores',
            attribute_values_list:      'Lista de Valores',
            attribute_value_new:        'Novo valor',
            banners:                    'Banners',
            banners_list:               'Lista de banners',
            banner_new:                 'Novo banner',
            brands:                     'Marcas',
            brands_list:                'Lista de marcas',
            brand_new:                  'Nova marca',
            calendar:                   'Calendário',
            categories:                 'Categorias',
            categories_list:            'Lista de categorias',
            category_new:               'Inserir categoria',
            content:                    'Conteúdo',
            content_list:               'Lista de conteúdos',
            content_new:                'Novo conteúdo',
            contest:                    'Concurso',
            contest_list:               'Lista de inscritos',
            contest_new:                'Novo inscrito',
            country_list:               'Lista de países',
            courses:                    'Cursos',
            courses_available:          'Cursos disponíveis',
            courses_ended:              'Concluídos',
            courses_in_progress:        'A decorrer/a iniciar',
            courses_new:                'Novo curso',
            courses_list:               'Lista de cursos',
            date_registration_begin:  'Data de início de inscrição',
            date_registration_deadline:  'Data limite de inscrição',
            estancia:                   'Estância',
            estancia_meios:             'Meios Mecanicos',
            estancia_meios_list:        'Lita de meios mecanicos',
            estancia_meio_new:          'Inserir meio',
            estancia_meio_add:          'Adicionar meio',
            estancia_pistas:            'Pistas',
            estancia_pistas_list:       'Lita pistas',
            estancia_pista_new:         'Inserir pista',
            estancia_pista_add:         'Adicionar pista',
            features:                   'Características',
            features_list:              'Lista de características',
            feature_new:                'Novo característica',
            feature_values:             'Valores',
            feature_values_list:        'Lista de Valores',
            feature_value_new:          'Novo valor',
            formation:                  'Formação',
            formation_list:             'Lista de formações',
            formation_new:              'Nova formações',
            messages:                   'Mensagens',
            messages_list:              'Lista de mensagens',
            messages_new:               'Nova mensagem',
            module:                     'Módulo',
            modules:                     'Módulos',
            module_list:                'Lista de módulos',
            module_new:                 'Novo módulo',
            galleries:                  'Galerias',
            galleries_list:             'Lista de galerias',
            gallery_new:                'Inserir galeria',
            menus:                      'Menus',
            menus_list:                 'Lista de menus',
            menu_new:                   'Inserir menu',
            my_courses:                 'Os meus cursos',
            painel_principal:           'Painel Principal',
            normas_submissao:           'Normas de submissão',
            energy_entity:              'Entidade',
            energy_entities_list:       'Lista de Entidades',
            energy_entity_new:          'Nova entidade',
            operation:                  'Operação',
            operations_list:            'Lista de Operações',
            operation_new:              'Nova operação',
            consumo:                    'Consumo',
            consumos_list:              'Lista de consumos',
            consumo_new:                'Nova consumo',
            autoconsumo:                'Autoconsumo',
            autoconsumos_list:          'Lista de autoconsumos',
            autoconsumo_new:            'Nova autoconsumo',
            plano_accao:                'Plano de Acção',
            plano_accao_list:           'Lista de planos de acção',
            plano_accao_new:            'Nova acção',
            resultado:                  'Resultados',
            resultados_list:            'Lista de resultados',
            resultado_new:              'Novo resultado',
            evento:                     'Evento',
            lista_eventos:              'Lista de Eventos',
            inserir_evento:             'Inserir Evento',
            call_for_papers:            'Call for papers',
            lista_cfp:                  'Lista de Cfp',
            inserir_cfp:                'Inserir Cfp',
            perfis:                     'Perfis',
            lista_perfis:               'Lista de perfis',
            inserir_perfil:             'Novo perfil',
            novo:                       'Novo',
            notes:                      'Notas',
            notes_list:                 'Lista de notas',
            note_new:                   'Nova nota',
            autor:                      'Autor',
            lista_autores:              'Lista de autores',
            revisor:                    'Revisor',
            lista_revisores:            'Lista de revisores',
            editor:                     'Editor',
            lista_editores:             'Lista de editores',
            artigo:                     'Artigo',
            novo_artigo:                'Adicionar artigo',
            lista_artigos:              'Lista de artigos',
            conteudo_site:              'Conteúdo site',
            conteudo:                   'Conteúdo',
            novo_conteudo:              'Novo conteúdo',
            difusao_cientifica:         'Difusão',
            revista:                    'Revista',
            conferencia:                'Conferência',
            nova_difusao:               'Nova difusão',
            termos:                     'Termos',
            termos_condicoes:           'Termos e condições',
            store:                      'Loja Online',
            store_products:             'Produtos',
            store_products_list:        'Lista de Produtos',
            store_product_new:          'Inserir Produtos',
            store_product_add:          'Adicionar Produtos',
            projects:                   'Projectos',
            project_areas:              'Áreas temáticas',
            project_areas_list:         'Lista de áreas',
            project_area_new:           'Inserir área',
            project_area_add:           'Adicionar áreas',
            project_domains:            'Dominios',
            project_domains_list:       'Lista de Dominios',
            project_domain_new:         'Inserir dominio',
            project_domain_add:         'Adicionar dominio',
            project_funds:              'Fundos',
            project_funds_list:         'Lista de Fundos',
            project_fund_new:           'Inserir fundo',
            project_fund_add:           'Adicionar fundo',
            project_parameters:         'Parametros',
            project_programs:           'Programas',
            project_programs_list:      'Lista de programas',
            project_program_new:        'Inserir programa',
            project_program_add:        'Adicionar programa',
            project_scopes:             'Ambito Territorial',
            project_scopes_list:        'Lista de ambitos',
            project_scope_new:          'Inserir ambito',
            project_scope_add:          'Adicionar ambito',
            politica_privacidade:       'Política de privacidade',
            store_parameters:           'Parametros',
            store_shipping:             'Envio',
            taxe_list:                  'Lista de taxas',
            testemonies:                'Testemunhos',
            testemonies_list:           'Lista de testemunhos',
            testemony_new:              'Inserir testemunho',
            trainer:                    'Formador',
            trainer_list:               'Lista de formadores',
            trainer_new:                'Adicionar formador',
            trainee:                    'Formando',
            trainee_list:               'Lista de formandos',
            trainee_new:                'Adicionar formando',
            webuser:                    'Utilizadores',
            webuser_list:               'Lista de utilizadores',
            webuser_new:                'Inserir utilizador',
            zone_list:                  'Lista de zonas',
        },
    'en':
        {
            articles:                   'News',
            articles_list:              'Articles list',
            article_new:                'New article',
            attributes:                 'Attributes',
            attributes_list:            'Attributes list',
            attribute_new:              'New attribute value',
            attribute_values:           'Attribute values',
            attribute_values_list:      'Attribute values list',
            attribute_value_new:        'New attribute value',
            banners:                    'Banners',
            banners_list:               'Banners List',
            banner_new:                 'New banner',
            brands:                     'Brands',
            brands_list:                'Brands list',
            brand_new:                  'New brand',
            calendar:                   'Calendar',
            categories:                 'Categories',
            categories_list:            'Categories list',
            category_new:               'Insert category',
            content:                    'Content',
            content_list:               'Content List',
            content_new:                'Insert content',
            contest:                    'Contest',
            contest_list:               'Subscription list',
            contest_new:                'New subscription',
            country_list:               'Country list',
            courses:                    'Cursos',
            courses_available:          'Available courses',
            courses_ended:              'Concluídos',
            courses_in_progress:        'In progress/to start',
            courses_new:                'Novo curso',
            courses_list:               'Lista de cursos',
            date_registration_begin:  'Data de início de inscrição',
            date_registration_deadline:  'Data limite de inscrição',
            estancia:                   'Estância',
            estancia_meios:             'Meios Mecanicos',
            estancia_meios_list:        'Lita de meios mecanicos',
            estancia_meio_new:          'Inserir meio',
            estancia_meio_add:          'Adicionar meio',
            estancia_pistas:            'Pistas',
            estancia_pistas_list:       'Lita pistas',
            estancia_pista_new:         'Inserir pista',
            estancia_pista_add:         'Adicionar pista',
            features:                   'Features',
            features_list:              'Features list',
            feature_new:                'Insert feature',
            feature_values:             'Feature values',
            feature_values_list:        'Feature values list',
            feature_value_new:          'New feature value',
            formation:                  'Formation',
            formation_list:             'Formation list',
            formation_new:              'New formation',
            messages:                   'Mensagens',
            messages_list:              'Lista de mensagens',
            messages_new:               'Nova mensagem',
            galleries:                  'Galleries',
            galleries_list:             'Galleries List',
            gallery_new:                'Insert gallery',
            menus:                      'Menus',
            menus_list:                 'Menus list',
            menu_new:                   'Insert menu',
            my_courses:                 'My courses',
            painel_principal:           'Dashboard' ,
            normas_submissao:           'Submission rules',
            energy_entity:              'Entidade',
            energy_entities_list:       'Lista de Entidades',
            energy_entity_new:          'Nova entidade',
            operation:                  'Operação',
            operations_list:            'Lista de Operações',
            operation_new:              'Nova operação',
            consumo:                    'Consumo',
            consumos_list:              'Lista de consumos',
            consumo_new:                'Nova consumo',
            autoconsumo:                'Autoconsumo',
            autoconsumos_list:          'Lista de autoconsumos',
            autoconsumo_new:            'Nova autoconsumo',
            plano_accao:                'Plano de Acção',
            plano_accao_list:           'Lista de planos de acção',
            plano_accao_new:            'Nova acção',
            resultado:                  'Resultados',
            resultados_list:            'Lista de resultados',
            resultado_new:              'Novo resultado',
            evento:                     'Event',
            lista_eventos:              'Events list',
            inserir_evento:             'Add Event',
            call_for_papers:            'Call for papers',
            lista_cfp:                  'Cfp list',
            inserir_cfp:                'Add Cfp',
            perfis:                     'Profiles',
            lista_perfis:               'Profiles list',
            inserir_perfil:             'Add profile',
            novo:                       'Add',
            notes:                      'Notas',
            notes_list:                 'Lista de notas',
            note_new:                   'Nova nota',
            autor:                      'Author',
            lista_autores:              'Authors list',
            revisor:                    'Reviewer',
            lista_revisores:            'Reviewers list',
            editor:                     'Publisher',
            lista_editores:             'Publishers list',
            artigo:                     'Article',
            novo_artigo:                'Add article',
            lista_artigos:              'Articles list',
            conteudo_site:              'Content site',
            conteudo:                   'Content',
            novo_conteudo:              'Add content',
            difusao_cientifica:         'Dissemination',
            revista:                    'Journal',
            conferencia:                'Conference',
            nova_difusao:               'Add dissemination',
            termos:                     'Terms',
            termos_condicoes:           'Terms and conditions',
            store:                      'Online Store',
            store_products:             'Products',
            store_products_list:        'Products List',
            store_product_new:          'Insert Product',
            store_product_add:          'Add Product',
            projects:                   'Projects',
            project_areas:              'Thematic areas',
            project_areas_list:         'Areas List',
            project_area_new:           'Insert area',
            project_area_add:           'Add area',
            project_domains:            'Domains',
            project_domains_list:       'Domains List',
            project_domain_new:         'Insert domain',
            project_domain_add:         'Add domain',
            project_funds:              'Funds',
            project_funds_list:         'Funds List',
            project_fund_new:           'Insert fund',
            project_fund_add:           'Add fund',
            project_parameters:         'Parameters',
            store_shipping:             'Shipping',
            project_programs:           'Programs',
            project_programs_list:      'Programs List',
            project_program_new:        'Insert program',
            project_program_add:        'Add program',
            project_scopes:             'Territorial Scopes',
            project_scopes_list:        'Scopes List',
            project_scope_new:          'Insert scope',
            project_scope_add:          'Add scope',
            politica_privacidade:       'Privacy policy',
            store_parameters:           'Parameters',
            taxe_list:                  'Taxe List',
            testemonies:                'Testimonials',
            testemonies_list:           'Testimonials List',
            testemony_new:              'Insert Testimonial',
            trainer:                    'Formador',
            trainer_list:               'Lista de formadores',
            trainer_new:                'Adicionar formador',
            trainee:                    'Formando',
            trainee_list:               'Lista de formandos',
            trainee_new:                'Adicionar formando',
            webuser:                    'User',
            webuser_list:               'Users list',
            webuser_new:                'Insert user',
            zone_list:                  'Zone list',
        }
}

module.exports = {
    language
};
